// extracted by css-extract-rspack-plugin
export default {"cls1":"NavImpactStats-cls1_fB3","cls2":"NavImpactStats-cls2_ulH NavImpactStats-cls1_fB3"};